import React, { Component } from 'react';

import { Helmet } from "react-helmet";
import { name, year, appUrl, description, primary_color, email } from "../Constant";
import FavIcon from "../Assets/favicon.png";
import ogImage from "../Assets/logo.png";

function Head(props){
    var title = props.title && props.title != "" ? props.title + " - " + name : name;
   
    return(
    <div>
      <Helmet>
    <title>{title || name}</title>
    {/*
    <base target="_blank" href={appUrl} />
    <base target="_self" href={appUrl} />
    */}
    <meta property="og:type" content="article" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={appUrl} />
    <meta property="og:image" content={ogImage} />
    <meta property="og:site_name" content={name} />
    <meta name="twitter:card" content={ogImage} />
    <meta name="twitter:image:alt" content={ogImage} />
    <meta name="keywords" content={description+", "+name} /> 
    <meta name="description" content={description} />
    <meta  content="30" />
    <meta name="subject" content="Script, Manuscript, Publishers, Scholars" />
    <meta name="copyright" content={name} />
    <meta name="language" content="EN" />
    <meta name="abstract" content="" />
    <meta name="topic" content="" />
    <meta name="summary" content="" />
    <meta name="Classification" content="Business" />
    <meta name="author" content={name + ", " +email} />
    <meta name="designer" content={name} />
    <meta name="copyright" content={name} />
    <meta name="reply-to" content={email} />
    <meta name="owner" content={name} />
    <meta name="url" content={appUrl} />
    <meta name="identifier-URL" content={appUrl} />
    <meta name="directory" content="submission" />
    <meta name="category" content="Publishing and Scholarly" />
    <meta name="coverage" content="Worldwide" />
    <meta name="distribution" content="Global" />
    <meta name="rating" content="General" />
    <meta name="revisit-after" content="7 days" />
    <meta http-equiv="Expires" content="0" />
    <meta http-equiv="Pragma" content="no-cache" />
    <meta http-equiv="Cache-Control" content="no-cache" />
     {/*Chrome, Firefox OS and Opera*/}
    <meta name="theme-color" content={primary_color} />
    <meta name="msapplication-navbutton-color" content={primary_color} />
    <meta name="apple-mobile-web-app-status-bar-style" content={primary_color} />
    <link rel="shortcut icon" href={FavIcon} type="image/png" />
    <link rel="icon" href={FavIcon} type="image/png" />
    <link rel="shortcut icon" href={FavIcon} type="image/png" sizes="16x16" />
    <link rel="icon" href={FavIcon} type="image/png" sizes="16x16" />
    <link rel="canonical" href={appUrl} />
    <link rel="apple-touch-icon" href={FavIcon} type="image/png" />
    <link rel="apple-touch-icon" sizes="120x120" href={FavIcon} type="image/png" />
    <link rel="apple-touch-icon" sizes="152x152" href={FavIcon} type="image/png" />
    <link rel="apple-touch-icon" sizes="167x167" href={FavIcon} type="image/png" />
    <link rel="apple-touch-icon" sizes="180x180" href={FavIcon} type="image/png" />
    <link rel="alternate" href={appUrl} hrefLang="EN" />

    <script type="text/javascript">
    
   {` 
   $(function(){
   //JS code goes here
   });
   `}
    </script>
    </Helmet>
   </div>
   );
   }

export default Head;